(() => {
  'use strict';

  if (window.__mellerQuickAddFastReady) return;
  window.__mellerQuickAddFastReady = true;

  const mobileMedia = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  const clearEvents = [
    'cart:update',
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'product-form:success',
    'ajaxProduct:added',
  ];

  const isMobileViewport = () => Boolean(mobileMedia?.matches);
  const closestRoot = (target) => target?.closest?.('[data-meller-quick-add-root]') || null;
  const getAddButton = (root) => root?.querySelector('.quick-add__button--add') || null;

  const clearBusy = (root) => {
    if (!root) return;

    root.removeAttribute('data-meller-quick-add-busy');
    getAddButton(root)?.removeAttribute('aria-busy');
  };

  const markMobileQuickAddSection = (root) => {
    if (!isMobileViewport() || !root?.closest) return;

    const section =
      root.closest('[id^="shopify-section-"]') ||
      root.closest('.shopify-section') ||
      root.closest('section') ||
      root.closest('.section');

    const carousel =
      root.closest('slideshow-component, .slideshow-component, slider-component, .slider-component') ||
      root.closest('.resource-list, .collection-list, .product-carousel');

    document.documentElement.setAttribute('data-meller-mobile-quick-add-used', 'true');
    root.setAttribute('data-meller-mobile-quick-add-used', 'true');
    section?.setAttribute('data-meller-mobile-quick-add-section', 'true');

    if (carousel) {
      carousel.setAttribute('data-meller-mobile-quick-add-carousel', 'true');
      const carouselSection =
        carousel.closest('[id^="shopify-section-"]') ||
        carousel.closest('.shopify-section, section, .section');
      carouselSection?.setAttribute('data-meller-mobile-quick-add-section', 'true');
    }
  };

  const handleSubmit = (event) => {
    const form = event.target;
    if (!form?.matches?.('form[data-type="add-to-cart-form"]')) return;

    const root = closestRoot(form);
    const variantInput = form.querySelector('input[name="id"]');
    const button = getAddButton(root);

    if (!root || !variantInput?.value || variantInput.disabled || !button || button.disabled) return;

    root.setAttribute('data-meller-quick-add-busy', 'true');
    button.setAttribute('aria-busy', 'true');
    markMobileQuickAddSection(root);

    const liveRegion = root.querySelector('[data-meller-quick-add-live-region]');
    if (liveRegion) liveRegion.textContent = 'Agregando producto al carrito';

    window.setTimeout(() => clearBusy(root), 2200);
  };

  const clearBusyRoots = () => {
    document.querySelectorAll('[data-meller-quick-add-root][data-meller-quick-add-busy]').forEach((root) => {
      clearBusy(root);
      markMobileQuickAddSection(root);
    });
  };

  document.addEventListener('submit', handleSubmit, true);
  clearEvents.forEach((eventName) => document.addEventListener(eventName, clearBusyRoots, true));
})();
